

/* Custom Slider Component */
if (!customElements.get('m-custom-slider-2')) {
  class MCustomSlider2 extends HTMLElement {
    constructor() {
      super();

      // 基础配置
      this.sectionId = this.dataset.sectionId;
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 5000;
      this.showArrows = this.dataset.showArrows === 'true';
      this.showDots = this.dataset.showDots === 'true';
      this.initialSlide = parseInt(this.dataset.initialSlide) || 0;
      this.centeredSlidesBounds = this.dataset.centeredSlidesBounds === 'true';
      this.preventClicks = !this.hasAttribute('swiper-clickable');
      this.slideToClickedSlide = this.dataset.slideToClickedSlide;

      // 高级配置
      this.direction = this.dataset.direction === 'vertical' ? 'vertical' : 'horizontal';
      this.slidesPerView = this.dataset.slidesPerView === 'auto' ? 'auto' : (parseInt(this.dataset.slidesPerView) || 1);
      this.slidesPerGroup = parseInt(this.dataset.slidesPerGroup) || 1;
      this.spaceBetween = parseInt(this.dataset.spaceBetween) || 0;
      this.loop = this.dataset.loop === 'true';
      this.effect = this.dataset.effect || 'slide'; // slide, fade, cube, coverflow
      this.speed = parseInt(this.dataset.speed) || 600;
      this.centeredSlides = this.dataset.centeredSlides === 'true';
      this.grabCursor = this.dataset.grabCursor !== 'false';
      this.freeMode = this.dataset.freeMode === 'true';

      // 响应式断点配置
      this.breakpoints = this.dataset.breakpoints ? JSON.parse(this.dataset.breakpoints) : {};

      // 内部状态
      this.slider = null;
      this.isInitialized = false;
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      console.log('Initializing Custom Slider...');

      // 立即显示内容
      // this.showContent();

      // 动态加载 Swiper 资源
      this.loadSwiperAssets().then(() => {
        this.setupSlider();
        this.showContent();
      }).catch((error) => {
        console.error('Failed to load Swiper assets:', error);
        this.showFallbackContent();
      });
    }

    showContent() {
      this.style.opacity = '1';
      this.classList.add('content-visible');
    }

    showFallbackContent() {
      // 如果 Swiper 加载失败，显示静态内容
      const slides = this.querySelectorAll('.swiper-slide');
      slides.forEach((slide, index) => {
        slide.style.display = index === 0 ? 'block' : 'none';
      });
      this.classList.add('swiper-fallback');
    }

    loadSwiperAssets() {
      return new Promise((resolve, reject) => {
        // 检查是否已有资源
        if (window.MinimogLibs && window.MinimogLibs.Swiper) {
          console.log('Swiper already available via MinimogLibs');
          resolve();
          return;
        }

        // 使用主题的 loadAssets 函数
        if (typeof loadAssets === 'function') {
          loadAssets(['swiper.css', 'swiper.js']).then(resolve).catch(reject);
        } else {
          // 手动加载
          this.manualLoadAssets().then(resolve).catch(reject);
        }
      });
    }

    manualLoadAssets() {
      return new Promise((resolve, reject) => {
        // 加载 CSS
        if (!document.querySelector('link[href*="swiper.css"]')) {
          const css = document.createElement('link');
          css.rel = 'stylesheet';
          css.href = window.Shopify?.routes?.root ?
            `${window.Shopify.routes.root}assets/swiper.css` :
            '/assets/swiper.css';
          document.head.appendChild(css);
        }

        // 加载 JS
        if (!window.Swiper && !window.MinimogLibs?.Swiper) {
          const script = document.createElement('script');
          script.src = window.Shopify?.routes?.root ?
            `${window.Shopify.routes.root}assets/swiper.js` :
            '/assets/swiper.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        } else {
          resolve();
        }
      });
    }

    setupSlider() {
      const swiperContainer = this.querySelector('.swiper-container');
      if (!swiperContainer) {
        console.error('Swiper container not found');
        return;
      }

      const slides = this.querySelectorAll('.swiper-slide');
      if (slides.length === 0) {
        console.warn('No slides found');
        this.classList.add('swiper-initialized');
        return;
      }

      // 构建 Swiper 配置
      const swiperConfig = this.buildSwiperConfig();
      console.warn(swiperConfig);

      // 获取 Swiper 构造函数
      const SwiperClass = window.MinimogLibs?.Swiper || window.Swiper;
      if (!SwiperClass) {
        console.error('Swiper not available');
        this.showFallbackContent();
        return;
      }

      try {
        // 初始化 Swiper
        this.slider = new SwiperClass(swiperContainer, swiperConfig);
        this.isInitialized = true;
        this.classList.add('swiper-initialized');

        console.log('Custom Slider initialized successfully');

        // 设置事件监听器
        this.setupEventListeners();

      } catch (error) {
        console.error('Failed to initialize Swiper:', error);
        this.showFallbackContent();
      }
    }

    buildSwiperConfig() {
      const config = {
        // 基础设置
        slidesPerView: this.slidesPerView,
        direction: this.direction,
        slidesPerGroup: this.slidesPerGroup,
        spaceBetween: this.spaceBetween,
        speed: this.speed,
        loop: this.loop,
        effect: this.effect,
        centeredSlides: this.centeredSlides,
        grabCursor: this.grabCursor,
        freeMode: this.freeMode,
        initialSlide: this.initialSlide,
        centeredSlidesBounds: this.centeredSlidesBounds,
        preventClicks: this.preventClicks,
        slideToClickedSlide: this.slideToClickedSlide,

        // 自动播放
        autoplay: this.autoplay ? {
          delay: this.autoplaySpeed,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        } : false,

        // 导航箭头
        navigation: this.showArrows ? {
          nextEl: this.querySelector('.sf-slider__controls-next'),
          prevEl: this.querySelector('.sf-slider__controls-prev'),
        } : false,

        // 分页指示器
        pagination: this.showDots ? {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
          dynamicBullets: false,
          bulletClass: 'swiper-pagination-dot',
          bulletActiveClass: 'swiper-pagination-dot-active',
          modifierClass: 'swiper-pagination-',
        } : false,

        // 默认响应式断点
        breakpoints: {

          // 合并用户自定义断点
          ...this.breakpoints
        },

        // 触控设置
        touchRatio: 1,
        touchAngle: 45,

        // 键盘控制
        keyboard: {
          enabled: true,
        },

        // 滚轮控制
        mousewheel: false,

        // 事件回调
        on: {
          init: () => {
            this.onSliderInit();
          },
          slideChange: () => {
            this.onSlideChange();
          },
          reachEnd: () => {
            this.onReachEnd();
          },
          reachBeginning: () => {
            this.onReachBeginning();
          }
        }
      };

      // 效果特定配置
      if (this.effect === 'fade') {
        config.fadeEffect = { crossFade: true };
      } else if (this.effect === 'cube') {
        config.cubeEffect = {
          shadow: true,
          slideShadows: true,
          shadowOffset: 20,
          shadowScale: 0.94,
        };
      } else if (this.effect === 'coverflow') {
        config.coverflowEffect = {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        };
      }

      return config;
    }

    setupEventListeners() {
      // Shopify Theme Editor 支持
      document.addEventListener('shopify:block:select', (e) => this.onBlockSelect(e));
      document.addEventListener('shopify:section:select', (e) => this.onSectionSelect(e));

      // 自定义事件
      this.addEventListener('customSlider:goToSlide', (e) => this.goToSlide(e.detail.index));
      this.addEventListener('customSlider:next', () => this.nextSlide());
      this.addEventListener('customSlider:prev', () => this.prevSlide());
    }

    // 事件回调方法
    onSliderInit() {
      this.dispatchEvent(new CustomEvent('customSlider:initialized', {
        detail: { slider: this.slider }
      }));
    }

    onSlideChange() {
      if (!this.slider) return;

      const activeIndex = this.slider.activeIndex;
      const realIndex = this.slider.realIndex;

      this.dispatchEvent(new CustomEvent('customSlider:slideChange', {
        detail: {
          activeIndex,
          realIndex,
          slider: this.slider
        }
      }));

      // 更新活动状态
      this.updateActiveSlide(realIndex);
    }

    onReachEnd() {
      this.dispatchEvent(new CustomEvent('customSlider:reachEnd'));
    }

    onReachBeginning() {
      this.dispatchEvent(new CustomEvent('customSlider:reachBeginning'));
    }

    updateActiveSlide(index) {
      const slides = this.querySelectorAll('.swiper-slide');
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
    }

    // Shopify Theme Editor 支持
    onBlockSelect(e) {
      if (!this.contains(e.target)) return;

      const block = e.target;
      const slideIndex = parseInt(block.dataset.slideIndex);

      if (!isNaN(slideIndex) && this.slider) {
        this.slider.slideToLoop ?
          this.slider.slideToLoop(slideIndex) :
          this.slider.slideTo(slideIndex);
      }
    }

    onSectionSelect(e) {
      if (!this.contains(e.target)) return;

      // 暂停自动播放（如果启用）
      if (this.slider && this.slider.autoplay) {
        this.slider.autoplay.stop();
      }
    }

    // 公共方法
    goToSlide(index) {
      if (!this.slider) return;

      this.slider.slideToLoop ?
        this.slider.slideToLoop(index) :
        this.slider.slideTo(index);
    }

    nextSlide() {
      if (!this.slider) return;
      this.slider.slideNext();
    }

    prevSlide() {
      if (!this.slider) return;
      this.slider.slidePrev();
    }

    play() {
      if (!this.slider || !this.slider.autoplay) return;
      this.slider.autoplay.start();
    }

    pause() {
      if (!this.slider || !this.slider.autoplay) return;
      this.slider.autoplay.stop();
    }

    destroy() {
      if (!this.slider) return;

      this.slider.destroy(true, true);
      this.slider = null;
      this.isInitialized = false;
      this.classList.remove('swiper-initialized');
    }

    // 组件卸载时清理
    disconnectedCallback() {
      this.destroy();
    }
  }

  // 注册自定义元素
  customElements.define('m-custom-slider-2', MCustomSlider2);
}
